module.exports = __webpack_public_path__ + "static/media/SF_nn_primaerlogo_vestland_pos.5fd8b741.pdf";